import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CoreTable from "../../coreComponents/Table/Table.tsx";
import Button from "../../coreComponents/Button/Button.tsx";
import { getAllUser } from "../../services/UserService.ts";

interface Vehicle {
  id: number;
  driverId: number;
  vehicle_no: string;
  vehicle_type: string;
}

interface UserData {
  id: number;
  name: string;
  location: string;
  dob: string;
  driving_license_no: string;
  email: string | null;
  isEmailVerified: boolean;
  isDeleted: boolean;
  phone: string;
  preferred_language: string;
  vehicles: Vehicle[];
  status: {
    status: string;
    message: string;
  };
}

const columns = [
  { id: "id", label: "ID" },
  { id: "name", label: "Name" },
  { id: "phone", label: "Phone" },
  { id: "email", label: "Email" },
  { id: "isEmailVerified", label: "Is Email Verified" },
  { id: "isDeleted", label: "Is Deleted" },
];

const User: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const navigate = useNavigate();
  const [userData, setUserData] = useState<UserData[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await getAllUser();
        if (response.data) {
          console.log(response.data);
          setUserData(response.data);
        }
      } catch (err: any) {
        if (err.response && err.response.status === 401) {
          console.error("Unauthorized access. Redirecting to login...");
          navigate("/login");
        } else {
          setError("Failed to fetch users");
          console.log(err);
        }
      }
      finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  const handleCreateUser = () => {
    // navigate("/create-user");
  };

  const handleUpdate = (id: number) => {
    console.log(`Update user with ID: ${id}`);
  };

  const handleDelete = (id: number) => {
    console.log(`Delete user with ID: ${id}`);
  };

  if (loading && userData.length === 0) return <div>Loading users...</div>;

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
      </div>
      <CoreTable
        columns={columns}
        data={userData.map((user) => ({
          ...user,
          isDeleted: user.isDeleted ? "true" : "false",
          isEmailVerified: user.isEmailVerified ? "true" : "false",
        }))}
        // onUpdate={handleUpdate}
        // onDelete={handleDelete}
      />
    </div>
  );
};

export default User;
